type LevelBadgeProps = {
    level: number;
    className?: string;
};

const LevelBadge = ({ level, className = "" }: LevelBadgeProps) => (
    <div className={`absolute level-badge rounded-full border border-[#65129C] flex items-center justify-center ${className}`}>
        <span className="text-white font-bold leading-none drop-shadow-sm">{level}</span>
    </div>
);

export default LevelBadge;
